module.exports = __webpack_public_path__ + "media/images/ski-c1c4c82deed322744d4fbcd7d51cc0da.png";